import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadECampaignListPage,
  unloadCampaignListPage
} from "../../redux/actions/asset.actions";
import CampaignList from "../../components/CampaignList";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function Campaigns() {
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadECampaignListPage());
    return () => dispatch(unloadCampaignListPage());
  }, []);

  if (!asset.campaigns) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"campaigns"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"campaigns"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <Link className="header-button" to="/campaigns/add">
                  {t("campaign.create_title")}
                </Link>
                <h2>{t("campaign.list_title")}</h2>
              </div>
              <CampaignList data={asset.campaigns} />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Campaigns;
